import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;

    // Pages where Google Analytics should NOT be loaded
    const excludedPaths = ['/login', '/admin', '/manufacturer', '/dealer'];
    
    // Check if current path should be excluded
    const shouldExclude = excludedPaths.some(path => 
      location.pathname.startsWith(path)
    );

    if (shouldExclude) return;

    // Load Google Analytics for allowed pages
    if (!window.gtag) {
      // Initialize dataLayer first
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;

      // Load gtag script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      
      script.onload = () => {
        gtag('js', new Date());
        gtag('config', GA_MEASUREMENT_ID);
      };

      document.head.appendChild(script);
    } else {
      // If gtag is already loaded, just send page view
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, [location.pathname, location.search]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics; 